import { Link } from 'react-router-dom';
import Footer from '../components/Footer.jsx';
import Header from '../components/Header.jsx';
import { Eyebrow } from '../components/Section.jsx';
import Seo from '../components/Seo.jsx';
import { CONTACT_EMAIL } from '../lib/site-config.js';
import { properties } from '../lib/property-config.js';

const staySlug = Object.keys(properties)[0];

function PolicySection({ kicker, title, children }) {
  return (
    <section className="border-t border-navy-100 py-6">
      <Eyebrow text={kicker} />
      <h2 className="mb-3 font-display text-xl font-semibold text-navy-900">{title}</h2>
      {/* prose-navy, not a size utility: the same 17px serif as the guides, and
          at the read measure about 72 to 78 characters a line. */}
      <div className="prose-navy space-y-3 text-navy-800">{children}</div>
    </section>
  );
}

export default function Terms() {
  return (
    <div className="mx-auto max-w-brief px-4 pt-6 sm:px-6">
      <Seo
        title="Terms · Charleston.Vacations"
        description="Terms of use for the Charleston.Vacations daily brief and direct booking."
      />
      <Header />
      {/* The article runs at the narrower long-form measure while the masthead
          stays at `brief` width, so the header keeps matching every other page. */}
      <article className="mx-auto max-w-read">
        <div className="mt-8 border-b border-navy-100 pb-6">
          <h1 className="font-display text-3xl font-semibold text-navy-900 sm:text-4xl">Terms</h1>
          <p className="mt-2 text-navy-600">Effective June 12, 2026.</p>
        </div>

        <PolicySection kicker="The brief" title="Conditions are a read, not a guarantee">
          <p>
            The daily brief assembles public weather, tide, marine, and traffic data with
            editorial judgment about how to spend the day. It's offered as-is for trip
            planning. Conditions change faster than any morning brief; checking actual
            conditions before you swim, boat, or drive is on you. Nothing here is navigation
            guidance, safety advice, or a substitute for official warnings. When NOAA or
            local authorities say otherwise, believe them, not us.
          </p>
        </PolicySection>

        <PolicySection kicker="Booking direct" title="Reservations & payment">
          <p>
            Direct bookings are paid through Stripe's secure checkout and created in our
            property-management system, which keeps the calendar in sync with Airbnb and
            Vrbo. Your dates are not held until checkout completes. The total price,
            including all fees and taxes, is shown before you pay; there are no service
            fees added on top. The cancellation policy for your dates is presented during
            checkout and in your confirmation email, and the house rules are in the{' '}
            <Link to={`/stay/${staySlug}/guide`} className="text-navy-700 underline">
              welcome guide
            </Link>.
          </p>
        </PolicySection>

        <PolicySection kicker="The fine print" title="Liability & changes">
          <p>
            To the fullest extent the law allows, Charleston.Vacations isn't liable for
            losses arising from reliance on the brief's conditions or recommendations, or
            from circumstances beyond our control affecting a stay (weather, evacuations,
            utility outages). Booking disputes are governed by South Carolina law. We may
            update these terms; the effective date above moves when we do.
          </p>
        </PolicySection>

        <PolicySection kicker="Talk to us" title="Questions">
          <p>
            Anything unclear, ask:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-navy-700 underline">{CONTACT_EMAIL}</a>.
            You'll get a person, not a ticket queue.
          </p>
        </PolicySection>
      </article>
      <Footer />
    </div>
  );
}
